// extracted by mini-css-extract-plugin
export default {"aboutUs":"AboutUs_aboutUs__luUdO","ourVision":"AboutUs_ourVision__1UD7W","ourStory":"AboutUs_ourStory__rpTo3","mobileName":"AboutUs_mobileName__x6FW9"};